import { Modal } from 'bootstrap';

Modal.Default.keyboard = false;
Modal.Default.backdrop = 'static';
